module.exports = "pegasus/assets/one-column-text-with-background-preview.png";